import { useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

const navLinks = [
	{ label: "How it Works", href: "/#trust" },
	{ label: "Services", href: "/#services" },
	{ label: "Trust & Escrow", href: "/#trust" },
	{ label: "FAQ", href: "/faq" },
];

export function Nav() {
	const [mobileOpen, setMobileOpen] = useState(false);

	return (
		<nav className="fixed top-4 right-0 left-0 z-50 flex justify-center px-4 pointer-events-none w-full">
			<div className="bg-white/90 backdrop-blur-lg shadow-card rounded-full px-4 py-2 flex items-center justify-between w-full max-w-5xl pointer-events-auto border border-gray-100">
				{/* Logo */}
				<a href="/" className="flex items-center px-3">
					<img
						src="/illustrations/logo-with-text.svg"
						alt="Proxi"
						className="h-8 w-auto"
					/>
				</a>

				{/* Desktop Links */}
				<div className="hidden md:flex items-center gap-8 px-6 font-medium text-sm text-slate">
					{navLinks.map((link) => (
						<a
							key={link.href}
							href={link.href}
							className="hover:text-primary transition-colors"
						>
							{link.label}
						</a>
					))}
				</div>

				{/* Actions */}
				<div className="flex items-center gap-3">
					<button
						type="button"
						data-tally-open="Bza1xR"
						data-tally-layout="modal"
						data-tally-width="700"
						data-tally-emoji-text="👋"
						data-tally-emoji-animation="wave"
						className="hidden sm:inline-flex bg-dark text-white text-sm font-semibold py-2.5 px-6 rounded-full hover:bg-primary transition-all hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap"
					>
						Join Waitlist
					</button>

					{/* Mobile Toggle */}
					<button
						type="button"
						className="md:hidden p-2 text-dark"
						onClick={() => setMobileOpen(!mobileOpen)}
						aria-label={mobileOpen ? "Close menu" : "Open menu"}
					>
						{mobileOpen ? (
							<X size={24} weight="bold" />
						) : (
							<List size={24} weight="bold" />
						)}
					</button>
				</div>
			</div>

			{/* Mobile Menu */}
			<div
				className={cn(
					"absolute top-full left-4 right-4 mt-2 bg-white rounded-2xl shadow-card border border-gray-100 pointer-events-auto overflow-hidden transition-all duration-300",
					mobileOpen
						? "max-h-80 opacity-100"
						: "max-h-0 opacity-0 pointer-events-none",
				)}
			>
				<div className="p-4 flex flex-col gap-2">
					{navLinks.map((link) => (
						<a
							key={link.href}
							href={link.href}
							className="px-4 py-3 text-dark font-medium text-base hover:bg-surface rounded-xl transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							{link.label}
						</a>
					))}
					<hr className="border-gray-100 my-2" />
					<button
						type="button"
						data-tally-open="Bza1xR"
						data-tally-layout="modal"
						data-tally-width="700"
						data-tally-emoji-text="👋"
						data-tally-emoji-animation="wave"
						onClick={() => setMobileOpen(false)}
						className="bg-dark text-white text-center font-semibold py-3 px-6 rounded-full hover:bg-primary transition-all"
					>
						Join Waitlist
					</button>
				</div>
			</div>
		</nav>
	);
}
